import React from 'react';
import MaterialTable from '@material-table/core';
import AddIcon from '@mui/icons-material/Add';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import { Box, Fab, Paper } from '@mui/material';
import api from "../../services/api";
import { useStoreActions } from 'easy-peasy';
import DialogoRegiao from './DialogoRegiao';
import DialogoRegiaoUsuario from './DialogoRegiaoUsuario';
import { materialTableLocalization } from '../../config';

const Regiao = () => {

  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);

  const [rows, setRows] = React.useState([]);
  const [roles, setRoles] = React.useState([]);
  const [columns, setColumns] = React.useState([]);
  const [openDlgRegiao, setOpenDlgRegiao] = React.useState(false);
  const [openDlgRegiaoUsuario, setOpenDlgRegiaoUsuario] = React.useState(false);
  const [regiao, setRegiao] = React.useState(null);

  const loadUsers = async () => {
    startLoading();
    try {
      setRows((await api.http.get('/regioes')).data);
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    };
  };

  React.useEffect(async () => {
    startLoading();
    try {
      setColumns([
        { field: 'label', title: 'Região' },
        { field: 'estado', title: 'Estado' },
        { field: 'habilitado', title: 'Habilitado', type: "boolean" },
      ]);

      await loadUsers();
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  }, []);

  const onCloseDlgRegiao = (reload = false) => {
    setRegiao(null);
    setOpenDlgRegiao(false);
    if (reload) {
      loadUsers();
    }
  };

  const onCloseDlgRegiaoUsuario = (reload = false) => {
    setOpenDlgRegiaoUsuario(false);
  };

  const onRowClick = (event, rowData) => {
    setRegiao(rowData);
    setOpenDlgRegiao(true);
  };
  return (
    <Box sx={{ width: '100%' }}>
      <DialogoRegiao
        open={openDlgRegiao}
        onClose={onCloseDlgRegiao}
        roles={roles}
        regiao={regiao}
      />

      <DialogoRegiaoUsuario
        open={openDlgRegiaoUsuario}
        onClose={onCloseDlgRegiaoUsuario}
      />


      <Paper variant="outlined" className='center-box' sx={{ width: '100%', my: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <MaterialTable
            columns={columns}
            data={rows}
            title="Unidades Operacionais"
            onRowClick={onRowClick}
            localization={materialTableLocalization}
            style={{ flex: 1 }}
          />
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, ml: 2 }}>
            <Fab
              color="primary"
              aria-label="nova região"
              onClick={() => setOpenDlgRegiao(true)}
            >
              <AddIcon />
            </Fab>
            <Fab
              color="default"
              aria-label="Usuários por região"
              onClick={() => setOpenDlgRegiaoUsuario(true)}
            >
              <PublicOutlinedIcon />
            </Fab>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default Regiao;

{/* <MaterialTable
          columns={columns}
          data={rows}
          title="Regiões"
          onRowClick={onRowClick}
          localization={materialTableLocalization}
        />
      </Paper>
      <Fab color="primary" aria-label="nova região" onClick={() => {
        setOpenDlgRegiao(true);
      }}>
        <AddIcon />
      </Fab>
      <Fab color="default" aria-label="Usuários por região" onClick={() => {
        setOpenDlgRegiao(true);
      }}>
        <PublicOutlinedIcon />
      </Fab>

    </Box> */}
